import { useEffect } from 'react';
import { AppShell } from '@mantine/core';
interface CustomLayout {
  children?: any
}

const LayoutPublic = ({ children }: CustomLayout) => {

  useEffect(() => {
    document.title = 'Webkredit.ch';
  }, []);

  return (
      <AppShell
        header={{ height: 0 }}
        footer={{ height: 0 }}
        padding={'md'}
      >
        <AppShell.Main bg={'var(--mantine-color-white)'}>
          {children}
        </AppShell.Main>
      </AppShell>

  );
};

export default LayoutPublic;